import React from 'react';
import { useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import { painPoints } from '../cherrySoftwareContent';
import { PainIllustration } from './cherrySoftwareIllustrations';
import SectionHeader from './SectionHeader';
import GlassCard from './GlassCard';
import IconBadge from './IconBadge';

const PainPoints = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 8, md: 10 }}>
      <Grid container spacing={4} alignItems="center" mb={{ xs: 2, md: 4 }}>
        <Grid item xs={12} md={5}>
          <Box data-aos="fade-right" display="flex" justifyContent="center">
            <PainIllustration color={theme.palette.warning.main} />
          </Box>
        </Grid>
        <Grid item xs={12} md={7}>
          <SectionHeader
            overline={painPoints.overline}
            title={painPoints.title}
            icon="build"
            align="left"
            maxWidth="100%"
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        {painPoints.items.map((item) => (
          <Grid item xs={12} md={4} key={item.id}>
            <GlassCard data-aos="fade-up" accentPalette={item.color || 'primary'}>
              <CardContent sx={{ p: 3 }}>
                <Box mb={2}>
                  <IconBadge
                    icon={item.icon}
                    color={item.color || 'primary'}
                    variant="gradient"
                    size={44}
                    rounded="12px"
                  />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5, lineHeight: 1.3 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary" sx={{ lineHeight: 1.75 }}>
                  {item.text}
                </Typography>
              </CardContent>
            </GlassCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PainPoints;
